import { render, staticRenderFns } from "./ticketsSoldHistoryModal.vue?vue&type=template&id=5ed0ebbc&"
import script from "./ticketsSoldHistoryModal.vue?vue&type=script&lang=js&"
export * from "./ticketsSoldHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports